import React from 'react';
import ChatAvatar from './ChatAvatar';
import MessageBubble from './MessageBubble';
import type { ChatMessage, ChatRoom, ChatRoomMember } from '../../types/chat';

interface MessageGroupProps {
  messages: ChatMessage[];
  sender: ChatRoomMember | undefined;
  isSelf: boolean;
  room?: ChatRoom;
  selfId?: string | null;
  onEdit?: (messageId: string) => void;
  onDelete?: (messageId: string) => void;
}

const MessageGroup: React.FC<MessageGroupProps> = ({
  messages,
  sender,
  isSelf,
  room,
  selfId,
  onEdit,
  onDelete,
}) => {
  if (messages.length === 0) return null;

  return (
    <div className={`flex gap-2.5 mb-3 ${isSelf ? 'flex-row-reverse' : ''}`}>
      {!isSelf && (
        <ChatAvatar
          src={sender?.avatar_url}
          name={sender?.full_name ?? sender?.email}
          size={32}
          online={sender?.is_online}
        />
      )}
      <div className={`flex flex-col gap-1 max-w-full ${isSelf ? 'items-end' : 'items-start'}`}>
        {messages.map((m) => (
          <MessageBubble
            key={m.id}
            message={m}
            isSelf={isSelf}
            canEdit={isSelf}
            room={room}
            selfId={selfId}
            onEdit={onEdit ? () => onEdit(m.id) : undefined}
            onDelete={onDelete ? () => onDelete(m.id) : undefined}
          />
        ))}
      </div>
    </div>
  );
};

export default MessageGroup;
